<template>
  <div>
    <md-table>
      <md-table-row>
        <md-table-head v-for="(header, index) in tableHeaders" :key="index">{{ header.text }}</md-table-head>
        <md-table-head v-if="hasActions">Acciones</md-table-head>
        <md-table-head v-if="showSelect">Seleccionar</md-table-head>
      </md-table-row>

      <md-table-row v-for="item in tableData" :key="item.id">
        <template v-for="(header, index) in tableHeaders">
          <md-table-cell :md-label="header.text" :key="index">{{ item[header.value] }}</md-table-cell>
        </template>
        <md-table-cell v-if="hasActions" md-label="Acciones">
          <md-button class="md-success md-just-icon md-round" @click="showItem(item)">
            <md-icon>remove_red_eye</md-icon>
          </md-button>
        </md-table-cell>
        <md-table-cell v-if="showSelect" md-label="Seleccionar">
          <md-checkbox class="md-fail" v-model="selected" :value="item"></md-checkbox>
        </md-table-cell>
      </md-table-row>
      <md-table-row v-if="showSelect">
        <md-button
          class="md-primary"
          style="width: 40%; left: 220%;"
          :disabled="activeButton"
          @click="saveSubItems"
        >Aprobar siniestros</md-button>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "SimpleTable",
  props: {
    tableHeaders: Array,
    tableData: {
      type: Array,
      default: () => [],
    },
    hasActions: {
      type: Boolean,
      default: true,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: [],
  }),
  methods: {
    showItem(item) {
      this.$router.push({
        name: "Vista de siniestro",
        params: { id: item.sinisterId },
      });
    },
    saveSubItems() {
      this.$emit("saveSubItems");
      this.selected = [];
    },
  },
  watch: {
    selected(val) {
      this.$emit("subSelected", this.selected);
    },
  },
  computed: {
    activeButton() {
      if (this.selected.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Tables/SimpleTable.vue